import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white">
            <h1 className="h4 text-uppercase">Unmatched Domestic Payment</h1>
            <p className="mb-0">List of unmatched domestic payments</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/unmatched-domestic-payment/view-header.js